// extracted by mini-css-extract-plugin
export var productImage = "_jn-1";
export var viewLink = "_jn-2";
export var wishlistItem = "_jn-0";